export default {
    VALID: 1,
    BAD: 2,
    ALTERNATE: 3,
    1: 'Valid',
    2: 'Bad',
    3: 'Alternate'
};